import * as React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Action, Dispatch} from "redux";
import {InjectedFormProps, reduxForm} from "redux-form";
import {ConstBorderRound, ConstBreakPoint, ConstColor,} from "src/config/styles_const/styles_const";
import Assets from "src/presentation/assets/img/assets";
import {AuthStateType} from "src/presentation/auth_state_type";
import BadgeBorder from "src/presentation/common/atom/badge/badge_border";
import {AuthState} from "src/presentation/store/auth_state";
import styled from "styled-components";
import {skillTagConfig} from "../../../../../config/language/ja-JP/domain/model_text";
import {Company, Status} from "../../../../../domain/model/company";
import {Customer, Status as CustomerStatus,} from "../../../../../domain/model/customer";
import {JobCareer} from "../../../../../domain/model/job_career";
import {PastCaseProject} from "../../../../../domain/model/past_case_project";
import {SearchHighlight} from "../../../../../domain/model/search_highlight";
import {OccupationSkillTag} from "../../../../../domain/model/skill_tag";
import BtnCorporateSmall from "../../../../common/atom/btn/btn_corporate_small";
import {AppState} from "../../../../store/app_state";
import ClientCustomerMainV2 from "../../customer/client_customer_main_v2";

interface IStateProps {
    initialValues:
        | {
        customer: Customer | null;
    }
        | undefined;
    formValues: any;
}

interface IProps extends IStateProps {
    isClientBookmark: boolean;
    company: Company | null;
    jobCareers?: JobCareer[];
    highlights?: SearchHighlight[];
    pastCaseProjects: PastCaseProject[];
    occupationSkillTags: OccupationSkillTag[];
    handleCreateClientBookmark?: (event: any) => void;
    handleDeleteClientBookmark?: (event: any) => void;
    authState: AuthState;
}

interface IState {
    showRegisterModal: boolean;
}

const validate = (values: any) => {
    const errors: any = {};
    return errors;
};

const CreateFavoriteString: string = "お気に入り登録";
const DeleteFavoriteString: string = "お気に入り解除";

export class ClientScoutCustomerSidebarScoutFirstForm extends React.Component<
    IProps & InjectedFormProps<{}, IProps>,
    IState
> {
    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);

        this.state = {
            showRegisterModal: false,
        };
    }

    public render(): JSX.Element {
        const {
            handleSubmit,
            jobCareers,
            isClientBookmark,
            pastCaseProjects,
            handleCreateClientBookmark,
            handleDeleteClientBookmark,
            highlights,
            company,
            occupationSkillTags,
            authState,
        } = this.props;
        const {customer} = this.props.initialValues;

        if (!customer || !jobCareers) {
            return <div/>;
        }

        let res: JSX.Element;

        const getOccupationQS = (name: string): string => {
            const tmp = name.split(">").map((v) => v.trim());

            if (tmp.length === 3) {
                const rawCategory = tmp[0];
                const rawParent = tmp[1];
                const rawChild = tmp[2];

                let category = 0;
                let parentId = "";
                let childId = "";

                skillTagConfig.occupationSkillTagCategoryList.forEach((v, k) => {
                    if (v.trim() === rawCategory) {
                        category = k;
                    }
                });

                for (const tag of occupationSkillTags) {
                    if (tag.name.trim() === rawParent) {
                        parentId = tag.id;
                        break;
                    }
                }

                for (const tag of customer.occupationSkillTags) {
                    if (tag.name.trim() === rawChild) {
                        childId = tag.id;
                        break;
                    }
                }

                return `otc=${category}&otp=${parentId}&ot=${childId}`;
            } else if (tmp.length === 2) {
                const rawCategory = tmp[0];
                const rawTag = tmp[1];

                let category = 0;
                let tagId = "";

                skillTagConfig.occupationSkillTagCategoryList.forEach((v, k) => {
                    if (v.trim() === rawCategory) {
                        category = k;
                    }
                });

                for (const tag of customer.occupationSkillTags) {
                    if (tag.name.trim() === rawTag) {
                        tagId = tag.id;
                        break;
                    }
                }

                return `otc=${category}&otp=${tagId}`;
            }

            return "";
        };

        // 通常ページ

        res = (
            <div style={{position: "relative"}}>
                {this.state.showRegisterModal && (
                    <BlackoutLayer>
                        <img src={Assets.publicCustomerIcon} style={{width: 370}}/>
                        <p
                            style={{
                                color: "white",
                                fontWeight: "bold",
                                fontSize: 40,
                                marginTop: 44,
                            }}
                        >
                            EXPERT NETWORKのご利用ありがとうございます
                        </p>

                        <p
                            style={{
                                color: "white",
                                fontWeight: "bold",
                                fontSize: 18,
                                lineHeight: "30px",
                                marginTop: 20,
                                textAlign: "center",
                            }}
                        >
                            これより当サービスのご利用には
                            <span
                                style={{
                                    color: "#00D58E",
                                    fontSize: 22,
                                }}
                            >
                サービスへのご登録
              </span>
                            が必要です。
                            <br/>
                            以下のリンクより、ご登録をお願い致します。
                        </p>
                        <div style={{display: "flex", marginTop: 30, gap: "20px"}}>
                            <a
                                href="https://libera-inc.com/expertnetwork-client"
                                target="_blank"
                                style={{
                                    padding: "14px 40px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    backgroundColor: "#00D58E",
                                    border: "none",
                                    borderRadius: 4,
                                    fontSize: 15,
                                    cursor: "pointer",
                                }}
                            >
                                サービスの詳細ページを見る
                            </a>
                            <a
                                href="/apply_client/_register?route_info=lafool"
                                style={{
                                    padding: "14px 40px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    backgroundColor: "#00D58E",
                                    border: "none",
                                    borderRadius: 4,
                                    fontSize: 15,
                                    cursor: "pointer",
                                }}
                            >
                                登録をする（無料）
                            </a>
                        </div>
                    </BlackoutLayer>
                )}

                <RightActionButtons
                    name="ClientScoutCustomerMainScoutForm-first"
                    onSubmit={handleSubmit}
                >

                    {authState.authState === AuthStateType.LOGIN_USER && (
                        <>
                            {isClientBookmark ? (
                                <UnFavoriteBtn
                                    value={customer.id}
                                    onClick={handleDeleteClientBookmark}
                                    type={"button"}
                                >
                                    <img
                                        src={Assets.heartIconOn}
                                        style={{
                                            position: "absolute",
                                            left: 20,
                                            top: 10,
                                        }}
                                    />
                                    <span style={{
                                        position: "absolute",
                                        left: 40,
                                        top: 3
                                    }}>{DeleteFavoriteString}</span>
                                </UnFavoriteBtn>
                            ) : (
                                <FavoriteBtn
                                    value={customer.id}
                                    onClick={handleCreateClientBookmark}
                                    type={"button"}
                                >
                                    <img
                                        src={Assets.heartIcon}
                                        style={{position: "absolute", left: 20, top: 10}}
                                    />
                                    <span style={{
                                        position: "absolute",
                                        left: 40,
                                        top: 3
                                    }}>{CreateFavoriteString}</span>
                                </FavoriteBtn>
                            )}
                        </>
                    )}

                    {authState.authState === AuthStateType.UNKNOWN && (

                        <FavoriteBtn
                            value={customer.id}
                            onClick={() => {
                                this.setState(() => ({
                                    showRegisterModal: true,
                                }));
                            }}
                            type={"button"}
                        >
                            <img
                                src={Assets.heartIcon}
                                style={{position: "absolute", left: 20, top: 10}}
                            />
                            <span style={{position: "absolute", left: 40, top: 3}}>{CreateFavoriteString}</span>
                        </FavoriteBtn>

                    )}

                    {company &&
                        company.status !== Status.Status_Demo &&
                        customer.status !== CustomerStatus.Status_Hidden && (
                            <ScoutBtn
                                name="ClientScoutCustomerMainScoutForm-first-top-submit"
                                type={"submit"}
                            >
                                <img
                                    src={Assets.scoutIcon}
                                    style={{position: "absolute", left: 25, top: 10}}
                                />
                                <span style={{position: "absolute", left: 50, top: 3, height: 25}}>スカウトする</span>
                            </ScoutBtn>
                        )}

                    {company == null && (
                        <ScoutBtn
                            type={"button"}
                            onClick={() => {
                                this.setState(() => ({
                                    showRegisterModal: true,
                                }));
                            }}
                        >
                            <img
                                src={Assets.scoutIcon}
                                style={{position: "absolute", left: 25, top: 10}}
                            />
                            <span style={{position: "absolute", left: 50, top: 3, height: 25}}>スカウトする</span>
                        </ScoutBtn>
                    )}

                </RightActionButtons>

                <p
                    style={{
                        fontSize: 12,
                        fontWeight: "bold",
                        marginBottom: 12,
                        color: "#333",
                    }}
                >
                    職種
                </p>
                {customer.displayOccupationSkillTags.length > 0 && (
                    <OccupationBadgeWrapper>
                        {customer.displayOccupationSkillTags.map((val) => {
                            if (authState.authState !== AuthStateType.UNKNOWN) {
                                return (
                                    <Link
                                        key={val}
                                        // style={{ color: "#9a8c64" }}
                                        to={`/client/scout/customers?${getOccupationQS(val)}`}
                                    >
                                        <ScoutCustomerBadgeBorder>{val}</ScoutCustomerBadgeBorder>
                                    </Link>
                                );
                            } else {
                                return (
                                    <span
                                        key={val}
                                        style={{cursor: "pointer"}}
                                        onClick={() => {
                                            this.setState(() => ({
                                                showRegisterModal: true,
                                            }));
                                        }}
                                    >
                    <ScoutCustomerBadgeBorder>{val}</ScoutCustomerBadgeBorder>
                  </span>
                                );
                            }
                        })}
                    </OccupationBadgeWrapper>
                )}
                <ClientCustomerMainV2
                    customer={customer}
                    jobCareers={jobCareers}
                    pastCaseProjects={pastCaseProjects}
                    company={company}
                    onClickLinkAsPublic={() => {
                        this.setState(() => ({
                            showRegisterModal: true,
                        }));
                    }}
                />
            </div>
        );

        return res;
    }
}

const mapStateToProps = (state: AppState) => {
    return {
        authState: state.authReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm({
    form: "ClientScoutCustomerMainScoutForm",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
})(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(ClientScoutCustomerSidebarScoutFirstForm)
);

const FavoriteBtn = styled(BtnCorporateSmall)`
    width: 140px;
    height: 30px;
    display: block;
    background: #9a8c64;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    position: relative;
    padding: 0px;
    font-weight: bold;
    font-size: 12px;

    @media screen and (
        min-width: ${ConstBreakPoint.Default}) {
        width: 155px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
`;

const UnFavoriteBtn = styled(BtnCorporateSmall)`
    width: 140px;
    height: 30px;
    display: block;
    background: #eeeeee;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    position: relative;
    padding: 0px;
    color: black;
    font-weight: bold;
    font-size: 12px;

    @media screen and (
        min-width: ${ConstBreakPoint.Default}) {
        width: 155px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
`;

const ScoutBtn = styled(BtnCorporateSmall)`
    width: 140px;
    height: 30px;
    display: block;
    background: #9a8c64;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: 0px;
    position: relative;
    padding: 0px;
    font-weight: bold;
    font-size: 12px;

    @media screen and (
        min-width: ${ConstBreakPoint.Default}) {
        height: 30px;
        margin-top: 10px;
        width: 155px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
`;

const OccupationBadgeWrapper = styled.div`
    margin-bottom: 0px;
`;

const ScoutCustomerBadgeBorder = styled(BadgeBorder)`
    color: ${ConstColor.White};
    border: 1px solid #9a8c64;
    background-color: #9a8c64;
    border-radius: ${ConstBorderRound.BadgeBorder};
`;

const BlackoutLayer = styled.div`
    position: fixed; // 固定位置
    top: 0; // トップ位置
    left: 0; // 左位置
    right: 0; // 右位置
    bottom: 0; // ボトム位置
    background-color: rgba(0, 0, 0, 0.85); // 背景色（黒で半透明）
    z-index: 100000000; // z-indexで他の要素より前に表示
    display: flex; // フレックスボックス
    align-items: center; // 中央揃え（縦方向）
    justify-content: center; // 中央揃え（横方向）
    flex-direction: column;
`;

const RightActionButtons = styled.form`
    position: fixed;
    z-index: 10000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    top: auto;
    right: 0;
    bottom: 0;
    padding: 20px;
    padding-left: 100px;


    @media screen and (
        min-width: ${ConstBreakPoint.Default}) {
        display: block;
        width: 155px;
        top: 100px;
        right: 0;
        bottom: auto;
        padding: 0px;
    }
`;


// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer_first/client_scout_customer_main_scout_first_form.tsx